import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    wrapper: 'xs:w-full flex min-w-[320px] flex-col bg-white p-5 md:max-w-none',
    actionButtonWrapper: 'mt-auto',
    actionButton:
      'heading-xs mt-5 cursor-pointer font-[450] tracking-wider uppercase max-sm:mt-6'
  }
});
